// In a future migration, the catalogs will be combined into one.
export enum PropCatalogType {
  INTERIOR_PROP_CATALOG = "INTERIOR_PROP_CATALOG",
  EXTERIOR_PROP_CATALOG = "EXTERIOR_PROP_CATALOG",
  PROP_CATALOG = "PROP_CATALOG",
}

export enum HeadCasingType {
  NONE = "NONE",
  SLICES = "SLICES",
  STONE = "STONE",
  JACK_ARCH = "JACK_ARCH",
  TRIM = "TRIM",
  FULL_ARCH = "FULL_ARCH",
  ARCHED_SLICES = "ARCHED_SLICES",
  EYEBROW_TRIM = "EYEBROW_TRIM",
}

export enum WallRoofBaseBoardMode {
  NONE = "NONE",
  ROOF_TOP_PLUMB_CUT = "ROOF_TOP_PLUMB_CUT",
  ROOF_TOP_SQUARED_CUT = "ROOF_TOP_SQUARED_CUT",
  FULL = "FULL",
}

export enum WallRoofBaseBoardFilter {
  ALL_EDGES = "ALL_EDGES",
  HORIZONTAL_EDGES = "HORIZONTAL_EDGES",
  SLOPED_EDGES = "SLOPED_EDGES",
}

export enum WindowMullionType {
  ORTHOGONAL = "ORTHOGONAL",
  ORTHOGONAL_CUSTOM = "ORTHOGONAL_CUSTOM",
  RADIAL_CUSTOM = "RADIAL_CUSTOM",
  DISABLED = "DISABLED",
}

export enum ApronCasingType {
  DISABLED = "DISABLED",
  TRIM = "TRIM",
}

export enum SideCasingType {
  DISABLED = "DISABLED",
  TRIM = "TRIM",
}

export enum StoolCasingType {
  DISABLED = "DISABLED",
  TRIM = "TRIM",
}

export enum ShutterType {
  DISABLED = "DISABLED",
  PANEL = "PANEL",
  VENTED = "VENTED",
  SIMPLE_SLATS = "SIMPLE_SLATS",
  Z_SLATS = "Z_SLATS",
  GENERIC = "GENERIC",
}

export enum ShutterShapeType {
  RECTANGULAR = "RECTANGULAR",
  ARCHED = "ARCHED",
}

export enum ShutterVerticalAlignment {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
}

export enum ShutterConfigurationType {
  BOTH = "BOTH",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum ExteriorWallOffsetMode {
  OUTSIDE_THICKENING = "OUTSIDE_THICKENING",
  INSIDE_THICKENING = "INSIDE_THICKENING",
  INSIDE_THICKENING_ALL = "INSIDE_THICKENING_ALL",
}

export enum WainscotingCapType {
  NONE = "NONE",
  CAP = "CAP",
}

export enum FasciaTopTrimSize {
  TWO_INCH = "TWO_INCH",
  THREE_INCH = "THREE_INCH",
  FOUR_INCH = "FOUR_INCH",
}

export enum EaveType {
  BOXED_BOX = "BOXED_BOX",
  BOXED_OPEN = "BOXED_OPEN",
  BOXED_MINI_HIP = "BOXED_MINI_HIP",
  BOXED_MINI_SHED = "BOXED_MINI_SHED",
  BOXED_FULL_RETURN = "BOXED_FULL_RETURN",
  ANGLED_ENCLOSED_OPEN = "ANGLED_ENCLOSED_OPEN",
  ANGLED_OPEN_OPEN = "ANGLED_OPEN_OPEN",
}

export enum EaveCutType {
  PLUMB = "PLUMB",
  SQUARED = "SQUARED",
}

export enum WrapFriezeBoardMode {
  NONE = "NONE",
  FULL = "FULL",
  SIDES = "SIDES",
  BOTTOM = "BOTTOM",
}

export enum EaveFriezeBoardMode {
  EAVE_AND_EAVE_RETURNS = "EAVE_AND_EAVE_RETURNS",
  EAVE = "EAVE",
  LEGACY_EAVE = "LEGACY_EAVE",
}

export enum RakeFriezeBoardMode {
  WALL_AND_SOFFIT = "WALL_AND_SOFFIT",
  WALL = "WALL",
}

export enum DormerWallBaseBoardMode {
  NONE = "NONE",
  FRONT = "FRONT",
  SIDES = "SIDES",
  FRONT_AND_SIDES = "FRONT_AND_SIDES",
}

export enum AwningType {
  DISABLED = "DISABLED",
  SHED = "SHED",
}

/**
 * @deprecated - only used to support TRIANGLE generated prop that is not contained within exteriorPropCatalog
 */
export enum PorchColumnBracketType {
  DISABLED = "DISABLED",
  FRENCH_COUNTRY = "FRENCH_COUNTRY",
  TALL_TAPERED = "TALL_TAPERED",
  TRIANGLE = "TRIANGLE",
}

export enum ColonnadeTerminationType {
  NO_COLUMN = "NO_COLUMN",
  COLUMN = "COLUMN",
}

export enum WallIntersectionType {
  NONE = "NONE",
  TEE = "TEE",
  CORNER = "CORNER",
  CORNER_REVERSE = "CORNER_REVERSE",
  LINE = "LINE",
}

export enum PorchHeaderTrimAlignment {
  TOP_OF_HEADER = "TOP_OF_HEADER",
  BOTTOM_OF_HEADER = "BOTTOM_OF_HEADER",
}

export enum TrimJustification {
  ABOVE = "ABOVE",
  BELOW = "BELOW",
}

export enum DoorPathColumnSpreadMode {
  FROM_CENTER_LINE = "FROM_CENTER_LINE",
  FROM_DOOR_EDGES = "FROM_DOOR_EDGES",
}

export enum InteriorDimensionType {
  BY_ROOM_GROUP = "BY_ROOM_GROUP",
  BY_STRING = "BY_STRING",
}

export enum ConditionedAreaCalculationType {
  BY_ROOM_TYPE = "BY_ROOM_TYPE",
  BY_ROOM_ENCLOSURE = "BY_ROOM_ENCLOSURE",
}

export enum ExteriorDimensionType {
  THREE_ROW = "THREE_ROW",
  FOUR_ROW = "FOUR_ROW",
}

export enum ColumnDimensionType {
  CENTERLINE = "CENTERLINE",
  EDGE_OF_FRAMING = "EDGE_OF_FRAMING",
  HYBRID = "HYBRID",
  NONE = "NONE",
}

export enum PlanOrientation {
  DEFAULT = "DEFAULT",
  ROTATE_90_DEGREES = "ROTATE_90_DEGREES",
}

export enum PlanLineStyle {
  NONE = "NONE",
  DASHED = "DASHED",
  FULL = "FULL",
}

export enum UtilityDimensionType {
  OUTSIDE_EDGE_OF_SLAB = "OUTSIDE_EDGE_OF_SLAB",
  OUTSIDE_EDGE_OF_FOUNDATION = "OUTSIDE_EDGE_OF_FOUNDATION",
}

export enum ElevationNotePlacementType {
  IN_PLACE = "IN_PLACE",
  ON_PERIMETER = "ON_PERIMETER",
  BOUNDING_BOX = "BOUNDING_BOX",
}

export enum CornerBoardTrimAlignment {
  TO_FOUNDATION = "TO_FOUNDATION",
  BO_SOFFIT = "BO_SOFFIT",
  BO_SOFFIT_LEGACY = "BO_SOFFIT_LEGACY",
  BO_FRIEZE_BOARD = "BO_FRIEZE_BOARD",
}

export enum CornerBoardTrimHorizontalDatum {
  OUTSIDE_WALL_CORNER = "OUTSIDE_WALL_CORNER",
  INSIDE_WALL_CORNER = "INSIDE_WALL_CORNER",
  DORMER_WALL_CORNER = "DORMER_WALL_CORNER",
}

export enum CaseworkDoorStyle {
  SLAB = "SLAB",
  SHAKER = "SHAKER",
}

export enum RoofPeakDirection {
  AUTO = "AUTO",
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
  BY_LOW_RAIL_INDEX = "BY_LOW_RAIL_INDEX",
  BY_GABLE_END_RAIL_INDEX = "BY_GABLE_END_RAIL_INDEX",
}

export enum RoofBoundaryType {
  BOUNDING_BOX = "BOUNDING_BOX",
  CLIP_TO_PERIMETER = "CLIP_TO_PERIMETER",
}

export enum GableRoofType {
  DEFAULT = "DEFAULT",
  AUTO_SIDE_SHED_ROOF = "AUTO_SHED_ROOF",
  LEFT_SIDE_SHED_ROOF = "LEFT_SIDE_SHED_ROOF",
  RIGHT_SIDE_SHED_ROOF = "RIGHT_SIDE_SHED_ROOF",
}

export enum EaveFasciaHeightDatum {
  DEFAULT = "DEFAULT",
  HOST_ROOF = "HOST_ROOF",
  HOST_ROOF_START_TRUNCATION = "HOST_ROOF_START_TRUNCATION",
  HOST_ROOF_END_TRUNCATION = "HOST_ROOF_END_TRUNCATION",
}

export enum RoofStructureType {
  FLAT = "FLAT",
  VAULTED = "VAULTED",
}

export enum RoofWallMode {
  INTERIOR = "INTERIOR",
  EXTERIOR = "EXTERIOR",
}

export enum RoofWeldMode {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}
